import React, {useState} from "react";
import AccountAddonsTable from "./components/account-addons-table/account-addons-table";
import {observer} from "mobx-react-lite";
import './account-addons-card.scss';
import {AddonsSummaryPopup} from "./components/summary-popup-modal/summary-popup-modal";
import FontHeading4 from "../../../components/fonts/font-heading4/font-heading4";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import Card from "../../../components/layouts/card/card";
import {Button} from "../../../components/inputs/button/button";
import {BUTTON_VARIANTS} from "../../../components/inputs/button-variants";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import AddonsStoreList from "./stores/addons-store-list";
import SubscriptionPlansStore from "../../subscription-plans/stores/subscription-plans-store";
import dashboardSettingsStore from "../../../stores/dashboard-settings-store";
import { PROFILE_CAPABILITIES } from "../../../models/ProfileCapabilities";

interface IAccountAddonsSectionProps {

}

const AccountAddonsCard: React.FC<IAccountAddonsSectionProps> = observer(() => {
    const manageAddonsCapability = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.MANAGE_ADDONS);
    const [isShowModal, setIsShowModal] = useState(false);
    
    /** Hide entire section if manage add-ons is not supported */
    if (!manageAddonsCapability.isSupported) {
        return null;
    }
    
    return (
        <Card>
            <div className="account-addons-card">
                <div className="heading-section">
                    <div className="title-wrapper">
                        <div>
                            <FontHeading4 variant={FONT_VARIANT.BOLD}>
                                Manage Add-ons
                            </FontHeading4>
                        </div>
                        {SubscriptionPlansStore.isOnTrial &&
                            <div>
                                <FontBody1 color={FONT_COLOR.NEUTRAL3}>
                                    Add-ons will be available once trial period ends
                                </FontBody1>
                            </div>
                        }
                    </div>
                    <div className="summary-popup-button-wrapper">
                        {!SubscriptionPlansStore.isOnTrial &&
                            <Button
                                disabled={!AddonsStoreList.hasChanges() || AddonsStoreList.isRefreshingAddons}
                                onClick={() => setIsShowModal(true)}
                                text={'UPDATE BILLING'}
                                variant={BUTTON_VARIANTS.PrimaryAccent}
                            />
                        }
                    </div>
                </div>
                {!SubscriptionPlansStore.isLoading && (
                    <div>
                        <AccountAddonsTable addons={AddonsStoreList.addonsList}/>
                        {isShowModal &&
                            <AddonsSummaryPopup
                                cancelButton={{
                                    title: 'Close',
                                    onClick: () => {
                                        setIsShowModal(false)
                                    }
                                }}
                            />
                        }
                    </div>
                )
                }
            </div>
        </Card>
    )
});

export default AccountAddonsCard;